"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSearchInput = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var react_bootstrap_1 = require("react-bootstrap");
var borderRadius = '4px';
var iconWidth = '38px';
exports.StyledSearchInput = (0, styled_components_1.default)(react_bootstrap_1.InputGroup)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  > div {\n    border-top-left-radius: ", ";\n    border-bottom-left-radius: ", ";\n\n    span {\n      width: ", ";\n    }\n  }\n\n  > input {\n    border-top-right-radius: ", ";\n    border-bottom-right-radius: ", ";\n    width: calc(100% - ", ");\n  }\n"], ["\n  > div {\n    border-top-left-radius: ", ";\n    border-bottom-left-radius: ", ";\n\n    span {\n      width: ", ";\n    }\n  }\n\n  > input {\n    border-top-right-radius: ", ";\n    border-bottom-right-radius: ", ";\n    width: calc(100% - ", ");\n  }\n"])), borderRadius, borderRadius, iconWidth, borderRadius, borderRadius, iconWidth);
var templateObject_1;
